export default "__VITE_ASSET__CNEw_urG__"